import { api } from "./api";

export const notifications = {
  list: (opts = {}) => {
    const params = new URLSearchParams();
    if (opts.onlyUnread) params.set("onlyUnread", "1");
    if (opts.limit) params.set("limit", String(opts.limit));
    return api.get(`/api/notifications?${params.toString()}`);
  },
  markRead: (id) => api.post(`/api/notifications/${id}/read`),
  markAllRead: () => api.post(`/api/notifications/read-all`),
  get: (id) => api.get(`/api/notifications/${id}`),
  remove: (id) => api.delete(`/api/notifications/${id}`),
};
